import Nullstack from 'nullstack';
export default function IconArrowAutofitContent({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-arrow-autofit-content",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 4l-3 3l3 3"
  }), "   ", Nullstack.element("path", {
    d: "M18 4l3 3l-3 3"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "14",
    width: "16",
    height: "6",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M10 7h-7"
  }), "   ", Nullstack.element("path", {
    d: "M21 7h-7"
  }), " ");
}